import { useState } from 'react'

import { NextSeo } from 'next-seo'
import { useForm } from 'react-hook-form'

import AuthTextNodes from '@data/i18n/auth.json'

import fetcher from '@lib/fetcher'
import customerRecoverMutation from '@lib/mutations/customer-recover'

import EmailInput from '@components/form-controls/EmailInput'

interface IFormInput {
	email: string
	errorOther: string
}

export default function ForgotPasswordScreen() {
	const {
		register,
		handleSubmit,
		setError,
		clearErrors,
		formState: { errors }
	} = useForm<IFormInput>()

	const [showEmailMessage, setShowEmailMessage] = useState(false)

	const onSubmit = async (data: IFormInput) => {
		try {
			const res = await fetcher({
				query: customerRecoverMutation,
				variables: {
					email: data.email
				}
			})

			if (res.customerRecover.customerUserErrors.length === 0) {
				setShowEmailMessage(true)
			} else {
				setError('errorOther', {
					message:
						res.customerRecover.customerUserErrors[0].message ||
						'Something went wrong. Please try again.'
				})
			}

			console.log(res)
		} catch (e) {
			console.log('err', e)
			setError('errorOther', {
				message: (e as any).err?.[0].message || 'Something unexpected went wrong. Please try again.'
			})
		}
	}

	return (
		<>
			<NextSeo title="Reset Password" />
			<div className="py-14">
				{showEmailMessage ? (
				<p className="max-w-md mx-auto text-center px-4 mt-8">
					{AuthTextNodes.resetPassword.successMessage}
				</p>
			) : (
				<form
					onSubmit={(event) => {
						event.preventDefault()
						clearErrors()
						handleSubmit(onSubmit)()
					}}
					className="flex flex-col max-w-md mx-auto px-8 gap-y-4"
				>
					<h1 className="text-3xl text-center">{AuthTextNodes.resetPassword.cta}</h1>

					{/* Description */}
					<p className="mt-4 mb-10 font-medium text-center text-gray-500 max-md:text-sm">
						{AuthTextNodes.resetPassword.description}
					</p>

					<p>{errors.errorOther ? errors.errorOther.message : <>&nbsp;</>}</p>
					<EmailInput isFilled={false} register={register} />
					{errors.email && <p>{errors.email.message}</p>}

					<button className="button button-primary" type="submit">
						{AuthTextNodes.resetPassword.submit}
					</button>
				</form>
			)}
			</div>
		</>
	)
}
